import script from "./StoresDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StoresDialog.vue?vue&type=script&setup=true&lang=js"

import "./StoresDialog.vue?vue&type=style&index=0&id=e11338a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e11338a2"]])

export default __exports__